import { Component, OnInit } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  localUtilService: UtilService;
  isAdministrator = false;
  isRh = false;
  isSolution = false;

  constructor(
    private utilService: UtilService
  ) {
    this.localUtilService = utilService;
  }

  ngOnInit() {
    const user = this.localUtilService.getUser();

    this.isAdministrator = this.localUtilService.isAdmin();
    this.isRh = user.perfil.find(p => p.id === '3' || p.nome === 'Rh') ? true : false;
    this.isSolution = this.localUtilService.isSolution();
  }
}